import React from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { useDeleteTask, forceReloadTask } from '@hooks/API/Event/UseTask';

import { EventCommentsDocuments } from '@components/EventDrawer/EventDrawerUi/EventCommentsDocuments';
import { EventModelNameLineNonBooking } from '@components/EventDrawer/EventDrawerUi/EventModelNameLineNonBooking';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';

import { EventDetailsWrapper } from '../EventDrawerUi/EventUI';

const ModelInfo = styled.div``;

const TaskModelDetails = ({
    afterRemove,
    afterUpdate,
    event,
    onEditModelEvent,
    onUpdateTasks,
    onTouchForm,
    openedEventID,
    differentDescriptions,
}) => {
    const { mutateAsync: onDeleteToDo } = useDeleteTask();

    const handleRemoveEvent = async () => {
        try {
            await onDeleteToDo({ ID: event.ID, todoId: openedEventID.ID });
        } catch (error) {
            console.error('Remove Event Date Model Error => ', error);
        }
    };

    const handleUnlinkEvent = async () => {
        try {
            await Axios.put(`/todos/UnLink/${event.ID}`);
            onUpdateTasks();
        } catch (error) {
            console.error('Unlink Event Error => ', error);
        }
    };

    const modelNameLineProps = {
        actions: {
            onEdit: onEditModelEvent,
            onDelete: async () => {
                await handleRemoveEvent(event.ID);
                if (event.ID === openedEventID) {
                    afterRemove();
                } else {
                    onUpdateTasks();
                    afterUpdate();
                }
            },
            onUnlink: () => handleUnlinkEvent(),
            onStatusUpdate: () => {
                onUpdateTasks();
                afterUpdate();
            },
        },
        eventProperties: {
            eventType: 'ToDo',
            isSingle: false,
            hasExport: true,
        },
        event: event,
    };

    return (
        <>
            <ModelInfo>
                <EventModelNameLineNonBooking {...modelNameLineProps} />
            </ModelInfo>
            {differentDescriptions && (
                <EventDetailsWrapper>
                    <ResponsiveFlexContainer
                        leftMinWidth={140}
                        columns={[
                            {
                                content: <p className="is-label">description</p>,
                                isBorder: true,
                            },
                            {
                                content: <p className="is-content">{event.Description}</p>,
                            },
                        ]}
                    />
                </EventDetailsWrapper>
            )}
            <EventCommentsDocuments
                event={event}
                api="ToDoID"
                type="ToDo"
                contactId={event.ModelID}
                drawerMode
                fetchEvent={onUpdateTasks}
                disableTransaction={!event.Project}
                onTransactionCreatedOrUpdated={onUpdateTasks}
                onTouchForm={onTouchForm}
            />
        </>
    );
};

export default TaskModelDetails;
